import React, { useState, useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import Moment from "react-moment";

import "react-datepicker/dist/react-datepicker.css";
import "../styles/Master.css";
import DailyTable from "../components/tables/DailyTable";
import VetTable from "../components/tables/VetTable";
import MeasurementTable from "../components/tables/MeasurementTable";
import MicrochipTable from "../components/tables/MicrochipTable";
import TrackingDeviceTable from "../components/tables/TrackingDeviceTable";
import SampleTable from "../components/tables/SampleTable";
import MovementTable from "../components/tables/MovementTable";
import InfantFeedingTable from "../components/tables/InfantFeedingTable";
import ReleaseTable from "../components/tables/ReleaseTable";
import CriminalCaseOutcomeTable from "../components/tables/CriminalCaseOutcomeTable";
import { Typeahead } from "react-bootstrap-typeahead";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import axiosInstance from "../axiosInstance";

export default function Master() {
  const { reference } = useParams();
  const navigate = useNavigate();
  const [referenceNumber, setReferenceNumber] = useState("");
  const [record, setRecord] = useState({});
  const [criminalCase, setCriminalCase] = useState(false);
  const [options, setOptions] = useState([]);

  async function getReferences() {
    const result = await axiosInstance.get("/api/all-reference-numbers");
    const numbers = result.data;
    const refs = [];
    numbers.forEach((element) => {
      refs.push(element.reference_number);
    });
    setOptions(refs);
    if (reference) {
      const refResult = await axiosInstance.post(
        "/api/specific-reference-numbers",
        {
          reference_number: reference,
        }
      );
      setReferenceNumber(refResult.data);
    }
  }

  useEffect(() => {
    getReferences();
    if (reference) {
      populateMainDetails(reference);
    }
  }, []);

  const populateMainDetails = (ref) => {
    (async () => {
      const result = await axiosInstance.post("/api/get-record-ref", {
        reference_number: ref,
      });
      const trecords = result.data;
      const trecord = trecords[0];
      setCriminalCase(trecord.criminal_case);
      setRecord(trecord);
    })();
  };

  return (
    <div className="master">
      <div className="ref-select">
        <Form>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupReference">
                <Form.Label>Reference Number</Form.Label>
                <Typeahead
                  id="reference-number"
                  labelKey="name"
                  onChange={(e) => {
                    navigate(`/master/${e}`, { replace: true });
                    navigate(0);
                  }}
                  options={options}
                  placeholder="Choose a reference number..."
                  selected={referenceNumber}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </div>
      {referenceNumber !== "" && (
        <div>
          <div className="formGroup">
            <h2 className="heading">
              {referenceNumber[0].reference_number +
                " " +
                referenceNumber[0].name}
            </h2>
          </div>
          <div className="maindetails">
            <Row className="masterrow">
              <Col>
                <h5>Date:</h5>
                {moment().format("DD/MM/YYYY", record.date)}
              </Col>
              <Col>
                <h5>Criminal Case:</h5>
                {record.criminal_case === 1 ? " True" : " False"}
              </Col>
              <Col>
                <h5>Official Document Reference:</h5>
                {record.issue_voucher}
              </Col>
            </Row>
            <Row className="masterrow">
              <Col>
                <h5>Name:</h5>
                {record.name}
              </Col>
              <Col>
                <h5>Sex:</h5>
                {record.sex}
              </Col>
              <Col>
                <h5>Age:</h5>
                {record.age}
              </Col>
            </Row>
            <Row className="masterrow">
              <Col>
                <h5>Health:</h5>
                {record.health_condition}
              </Col>
              <Col>
                <h5>Weight:</h5>
                {record.weight} kgs
              </Col>
              <Col>
                <h5>Parasites Present:</h5>
                {record.parasites}
              </Col>
            </Row>

            <Row className="masterrow">
              <Col>
                <h5>Original Area:</h5>
                {record.area}
              </Col>
              <Col>
                <h5>Time in Captivity:</h5>
                {record.captivity_time} days
              </Col>
              <Col>
                <h5>Mode of Transport:</h5>
                {record.mode_of_transport}
              </Col>
            </Row>
            <Row className="masterrow">
              <Col>
                <h5>Details of Receiving:</h5>
                {record.receiving_details}
              </Col>
            </Row>
            <Row className="masterrow">
              <Col>
                <h5>Marks or Disfigurations:</h5>
                {record.issue_voucher}
              </Col>
            </Row>
            <Row className="masterrow">
              <Col>
                <h5>Authoritative Point of Contact:</h5>
                {record.authoritative_contact}
              </Col>
            </Row>
          </div>
          <div>
            <h4 className="mastersubheading">Daily Activities</h4>
            <div className="display-table">
              <DailyTable
                referenceNumber={referenceNumber[0].reference_number}
              />
            </div>
          </div>
          <div>
            <h4 className="mastersubheading">Veterinary Treatments</h4>
            <div className="display-table">
              <VetTable referenceNumber={referenceNumber[0].reference_number} />
            </div>
          </div>
          <div>
            <h4 className="mastersubheading">Physical Measurements</h4>
            <div className="display-table">
              <MeasurementTable
                referenceNumber={referenceNumber[0].reference_number}
              />
            </div>
          </div>
          <div>
            <h4 className="mastersubheading">Microchips</h4>
            <div className="display-table">
              <MicrochipTable
                referenceNumber={referenceNumber[0].reference_number}
              />
            </div>
          </div>
          <div>
            <h4 className="mastersubheading">Tracking Devices</h4>
            <div className="display-table">
              <TrackingDeviceTable
                referenceNumber={referenceNumber[0].reference_number}
              />
            </div>
          </div>
          <div>
            <h4 className="mastersubheading">Samples</h4>
            <div className="display-table">
              <SampleTable
                referenceNumber={referenceNumber[0].reference_number}
              />
            </div>
          </div>
          <div>
            <h4 className="mastersubheading">Interdepartmental Movement</h4>
            <div className="display-table">
              <MovementTable
                referenceNumber={referenceNumber[0].reference_number}
              />
            </div>
          </div>
          <div>
            <h4 className="mastersubheading">Infant Feeding</h4>
            <div className="display-table">
              <InfantFeedingTable
                referenceNumber={referenceNumber[0].reference_number}
              />
            </div>
          </div>
          <div>
            <h4 className="mastersubheading">Release</h4>
            <div className="display-table">
              <ReleaseTable
                referenceNumber={referenceNumber[0].reference_number}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
